import React from "react"
import { useTranslation } from "react-i18next"
import LittleCards from "../common/LittleCards"

const StrengthsOfIntroverts = () => {
  const { t } = useTranslation()

  return (
    <div className="p-5 space-y-4">
      <h2 className="text-2xl font-semibold">
        {t("introvert-insights.strengths.title")}
      </h2>
      <div className="py-5">
        <LittleCards
          items={t("introvert-insights.strengths.sectionMessage", {
            returnObjects: true,
          })}
        />
      </div>
    </div>
  )
}

export default StrengthsOfIntroverts
